<script lang="ts">
/* eslint-disable vue/no-v-html */

export interface PhxsgRichTextProps {
  centered?: boolean;
  html?: string;
}
</script>

<script setup lang="ts">
const { centered = false, html = undefined } = defineProps<PhxsgRichTextProps>();
</script>

<template>
  <div v-if="html === undefined" :class="['phxsg-rich-text', { 'phxsg-rich-text--centered': centered }]">
    <slot />
  </div>

  <div v-else :class="['phxsg-rich-text', { 'phxsg-rich-text--centered': centered }]" v-html="html" />
</template>

<style src="./rich-text.css" />
